<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col col-md-8 offset-md-2 text-center">
          <hr class="space space-sm d-none d-sm-block">
          <h1 class="title h1-xl py-4"><span class="text-primary">Partners</span>,<br>not an agency</h1>
          <p class="largest py-4">
            We are independents.<br>
            We don't have project managers.<br>
            A <span class="regular text-primary">resolute</span> member is your business partner.<br>
          </p>
          <p>
            When it comes to building new digital products, using a collective can be a game changer.
            Unlike agencies, collectives allow you to work <span class="regular text-primary">directly</span>
            with creatives and developers as if they're part of your team. This fosters a collaborative environment
            where ideas can flow freely, resulting in a better end product.
          </p>

          <hr class="space space-sm d-none d-sm-block">
          <router-link class="btn btn-primary" :to="{ name: 'about' }">About us</router-link>
          <router-link class="btn btn-outline-primary" :to="{ name: 'services' }">What we do</router-link>
          <hr class="space space-lg">
        </div>
      </div>
      <div class="row">
        <div class="col col-md-8 offset-md-2 text-center">
          <h1 class="title py-4">No middleman. <br class="d-none d-md-block"> <span class="text-primary">No overheads.</span></h1>
          <p class="larger py-4">
            Working with us is a more personalized experience compared to an agency. As partners, we are invested in the project's success and take a personal interest.
          </p>
          <p>
            Agencies may have project managers and middlemen, but this can create communication barriers and generate unnecessary costs.
            With a collective, you can cut out the middlemen and work directly with the team, building a stronger working relationship
            and getting the most out of their expertise.
          </p>
          <p>
            Many <span class="regular text-primary">resolute</span> partners join client projects as co-founders, shareholders or members of the board.
            This is entirely up to you and the person.
          </p>
          <hr class="space space-lg">
        </div>
      </div>
      <div class="row" v-if="clients && clients.length > 0">
        <div class="col text-center">
          <p class="text-center">
            Join the many big and small business who've worked with <span class="regular text-primary">resolute</span> members in the past:
          </p>
          <hr class="space space-sm">
          <div class="row clients">
            <div class="col-3 col-md mb-4 text-center pr-1" v-for="(client, index) in clients" :key="index">
              <img class="img-fluid" :src="client.logo" :alt="client.name">
            </div>
          </div>
          <hr class="space space-lg">
        </div>
      </div>
      <div class="row">
        <div class="col col-md-8 offset-md-2 text-center">
          <p>
            
          </p>
          <hr class="space space-xs">
          <router-link class="btn btn-primary" :to="{ name: 'request-proposal' }">Get in touch</router-link>
          <router-link class="btn btn-outline-primary" :to="{ name: 'home' }">Recent work</router-link>
        </div>
      </div>
      <hr class="space">
    </div>
    <hr class="space">
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'about',
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      clients: state => state.clients.clients
    })
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    this.$store.dispatch('LOAD_CLIENTS')
  },
  methods: {
  }
}
</script>
